import { NotificationType } from '@baserow/modules/core/notificationTypes'
import NotificationSenderInitialsIcon from '@baserow/modules/core/components/notifications/NotificationSenderInitialsIcon'
import { tableRouteResetViewIfNeeded } from '@baserow/modules/database/utils/routing'

import AvisoComentario from '@comentarios_mg/components/AvisoComentario'
import AvisoMencion from '@comentarios_mg/components/AvisoMencion'

/**
 * El aviso de "alguien comento en una fila en la que participas". Todo el marco
 * de notificaciones es del core y es MIT; esto solo declara el tipo y como se
 * pinta. Lleva nombre propio porque avisa de NUESTROS comentarios.
 */
export class AvisoComentarioNotificationType extends NotificationType {
  static getType() {
    return 'comentario_mg'
  }

  getIconComponent() {
    return NotificationSenderInitialsIcon
  }

  getContentComponent() {
    return AvisoComentario
  }

  getRoute(notificationData) {
    // Abre la fila directamente, que es donde esta la conversacion.
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}

/**
 * El aviso de "te mencionaron". Va aparte del general a proposito: no es lo
 * mismo "hay conversacion en una fila que sigues" que "te estan preguntando
 * algo a ti". A quien se menciona NO se le manda ademas el aviso general.
 */
export class AvisoMencionNotificationType extends NotificationType {
  static getType() {
    return 'mencion_mg'
  }

  getIconComponent() {
    return NotificationSenderInitialsIcon
  }

  getContentComponent() {
    return AvisoMencion
  }

  getRoute(notificationData) {
    return tableRouteResetViewIfNeeded(this.app.$router, {
      databaseId: notificationData.database_id,
      tableId: notificationData.table_id,
      rowId: notificationData.row_id,
    })
  }
}
